export default __webpack_public_path__ + "static/compareItemImg5-cb4a590d9cf7227faf09c1e305a1b014.webp";